'use client';

import React from 'react';

function PriceBox({
  price,
  prefix,
  className,
}: {
  price: number;
  prefix: string;
  className?: string;
}) {
  return (
    <span className={className}>
      <span>{price.toLocaleString()}</span>
      {prefix}
    </span>
  );
}

export default PriceBox;
